.page {
  position: absolute;
  inset: 0;
  overflow-y: auto;
  padding-bottom: calc(var(--safe-b) + 24px);
}

.header {
  position: sticky;
  top: 0;
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: calc(var(--safe-t) + 6px) 8px 6px;
  background: rgb(0 0 0 / 0.9);
  backdrop-filter: blur(16px);
}

.header h1 {
  font-size: var(--fs-md);
  font-weight: 800;
}

/* ---------- source ---------- */
.source {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 16px var(--gutter);
}

.sourceCard {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  padding: 24px 20px;
  border-radius: var(--r-xl);
  background: var(--surface-1);
  border: 1px solid var(--border);
  text-align: left;
  transition: border-color var(--t-fast), transform var(--t-fast) var(--ease);
}

.sourceCard:hover {
  border-color: rgb(var(--accent-rgb) / 0.6);
}

.sourceCard:active {
  transform: scale(0.98);
}

.sourceCard strong {
  font-size: var(--fs-lg);
  font-weight: 800;
}

.sourceCard small {
  color: var(--text-3);
  font-size: var(--fs-sm);
}

.sourceIcon {
  display: grid;
  place-items: center;
  width: 60px;
  height: 60px;
  border-radius: 18px;
  background: var(--accent);
  color: var(--accent-ink);
  margin-bottom: 10px;
}

.soundChip {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 6px 6px 6px 8px;
  border-radius: var(--r-lg);
  background: var(--surface-2);
}

.soundMain {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 12px;
  text-align: left;
}

.soundMain span:last-child {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.soundMain strong {
  font-size: var(--fs-sm);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.soundMain small {
  font-size: var(--fs-xs);
  color: var(--text-3);
}

.soundIcon {
  display: grid;
  place-items: center;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: var(--accent-soft);
  color: var(--accent);
}

/* ---------- edit ---------- */
.edit,
.details {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 8px var(--gutter);
}

.preview {
  position: relative;
  align-self: center;
  width: min(100%, 300px);
  aspect-ratio: 9 / 16;
  border-radius: var(--r-lg);
  overflow: hidden;
  background: #000;
  cursor: pointer;
}

.previewVideo {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.previewPlay {
  position: absolute;
  inset: 0;
  display: grid;
  place-items: center;
  background: rgb(0 0 0 / 0.25);
}

.mixer {
  display: grid;
  gap: 10px;
  padding: 14px 16px;
  border-radius: var(--r-lg);
  background: var(--surface-1);
}

.mixer label {
  display: grid;
  grid-template-columns: 120px 1fr;
  align-items: center;
  gap: 12px;
  font-size: var(--fs-sm);
  font-weight: 600;
  color: var(--text-2);
}

.mixer input,
.coverPicker input {
  accent-color: var(--accent);
  width: 100%;
}

.label {
  font-size: var(--fs-sm);
  font-weight: 700;
  color: var(--text-2);
}

.coverPicker {
  display: grid;
  gap: 8px;
}

.frames {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 4px;
}

.frame {
  aspect-ratio: 9 / 16;
  border-radius: 6px;
  overflow: hidden;
  background: var(--surface-2);
  outline: 2px solid transparent;
  outline-offset: -2px;
  transition: outline-color var(--t-fast);
}

.frame video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  pointer-events: none;
}

.frameActive {
  outline-color: var(--accent);
}

.soon {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: var(--fs-xs);
  color: var(--text-3);
}

/* ---------- details ---------- */
.captionRow {
  display: flex;
  gap: 12px;
}

.captionRow textarea {
  flex: 1;
  min-height: 150px;
  padding: 12px 14px;
  border-radius: var(--r-md);
  background: var(--surface-1);
  border: 1px solid var(--border);
  outline: none;
  resize: none;
  line-height: 1.45;
}

.captionRow textarea:focus {
  border-color: var(--accent);
}

.coverThumb {
  position: relative;
  width: 96px;
  aspect-ratio: 9 / 16;
  border-radius: 10px;
  overflow: hidden;
  background: var(--surface-2);
  flex-shrink: 0;
  align-self: flex-start;
}

.coverThumb video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.coverThumb span {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 4px;
  font-size: 11px;
  font-weight: 700;
  text-align: center;
  background: rgb(0 0 0 / 0.55);
}

.tagPreview {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.tagPreview span,
.tagPreview button {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 6px 10px;
  border-radius: var(--r-full);
  font-size: var(--fs-xs);
  font-weight: 700;
}

.tagPreview span {
  background: var(--accent-soft);
  color: var(--accent);
}

.tagPreview button {
  background: var(--surface-2);
  color: var(--text-2);
}

.visibility {
  border: 0;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}

.visibility legend {
  font-size: var(--fs-sm);
  font-weight: 700;
  color: var(--text-2);
  margin-bottom: 8px;
}

.visOption {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 14px 6px;
  border-radius: var(--r-md);
  background: var(--surface-1);
  border: 1px solid var(--border);
  font-size: var(--fs-sm);
  font-weight: 700;
  color: var(--text-2);
}

.visActive {
  border-color: var(--accent);
  color: var(--accent);
  background: var(--accent-soft);
}

/* ---------- publishing ---------- */
.publishing {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  padding: 80px 24px;
  text-align: center;
}

.publishing p {
  font-weight: 700;
  font-size: var(--fs-lg);
}

.publishing small {
  color: var(--text-3);
}

.ring {
  --p: 0;
  position: relative;
  display: grid;
  place-items: center;
  width: 140px;
  height: 140px;
}

.ring::before {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: 50%;
  background: conic-gradient(var(--accent) calc(var(--p) * 360deg), var(--surface-3) 0);
  mask: radial-gradient(circle, transparent 60px, black 61px);
  -webkit-mask: radial-gradient(circle, transparent 60px, black 61px);
  transition: background var(--t-med);
}

.ring span {
  position: relative;
  font-size: var(--fs-xl);
  font-weight: 800;
  font-variant-numeric: tabular-nums;
}

/* ---------- recorder ---------- */
.recorder {
  position: absolute;
  inset: 0;
  background: #000;
}

.recPreview {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.recTop {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: calc(var(--safe-t) + 8px) 8px;
  background: linear-gradient(rgb(0 0 0 / 0.5), transparent);
}

.recTimer {
  padding: 6px 12px;
  border-radius: var(--r-full);
  background: rgb(255 77 94 / 0.9);
  font-weight: 800;
  font-size: var(--fs-sm);
}

.recBottom {
  position: absolute;
  left: 0;
  right: 0;
  bottom: calc(var(--safe-b) + 30px);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 18px;
}

.recProgress {
  width: 70%;
  height: 4px;
  border-radius: 4px;
  background: rgb(255 255 255 / 0.25);
  overflow: hidden;
}

.recProgress span {
  display: block;
  height: 100%;
  background: var(--accent);
  transform-origin: left;
}

.recButton {
  display: grid;
  place-items: center;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  border: 5px solid white;
  color: var(--danger);
  transition: transform var(--t-fast) var(--ease-spring);
}

.recOn {
  transform: scale(1.1);
  border-color: var(--danger);
}

.recError {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 32px;
  text-align: center;
  color: var(--text-2);
}

/* ---------- sound picker ---------- */
.pickerSearch {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 16px 8px;
  padding: 0 14px;
  height: 44px;
  border-radius: var(--r-md);
  background: var(--surface-2);
  color: var(--text-3);
}

.pickerSearch input {
  flex: 1;
  background: none;
  border: 0;
  outline: none;
  color: var(--text);
}

.pickerCenter {
  display: grid;
  place-items: center;
  padding: 24px;
}

.pickerList {
  list-style: none;
  margin: 0;
  padding: 0 8px 20px;
}

.pickerItem {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 8px;
  border-radius: var(--r-md);
  text-align: left;
}

.pickerItem:hover:not(:disabled) {
  background: var(--surface-2);
}

.pickerItem:disabled {
  opacity: 0.45;
}

.pickerText {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.pickerText strong {
  font-size: var(--fs-sm);
}

.pickerText small {
  font-size: var(--fs-xs);
  color: var(--text-3);
}

.pickerBlocked {
  color: var(--warning) !important;
}
